import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import { toast } from "react-toastify";
import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput, SearchSubmitButton } from "../Form/Form";
import { addOneToDate } from "../../util/fn";
import { CSVLink } from "react-csv";
import { SendCreds } from "../../util/Svg";
import { API } from "../../constant/api";
import { ConfirmButton } from "../sweetalert";
import { requestHandler } from "../../services/requestHandler";
import AddTrackingId from "./AddTrackingId";
import JsonToScv from "../JsonToCsv";
import moment from "moment";
import { updateLoading } from "../../store/auth/action";

const apiName = "orders";
const titleSingular = "Order";
const titlePlural = "Orders";

const OBJ_TABLE = {
  "Order Number": "requestId",
  "Tracking Id": "orderTrackingUniqueId",
  customer: `customer`,
  "Brand Name": "brandName",
  "Model Name": "modelName",
  "Manufacture Year": "year",
  vin: "vin",
  "Total Items": "sparePartsLength",
  "Created On": "createdAt",
  status: "status",
  //   status: "isActive",
};

const csvHeader = [
  { label: "Order Number", key: "requestId" },
  { label: "Tracking Id", key: "orderTrackingUniqueId" },
  { label: "Customer Name", key: "customer" },
  { label: "Customer Contact", key: "contact" },
  { label: "Brand Name", key: "brandName" },
  { label: "Model Name", key: "modelName" },
  { label: "Manufacture Year", key: "year" },
  { label: "vin", key: "vin" },
  { label: "Total Items", key: "sparePartsLength" },
  { label: "Created On", key: "createdAt" },
];

const searchQueryHandler = (
  page,
  per_page,
  sortBy,
  order,
  isActive = "",
  requestId = "",
  customer = "",
  brandName = "",
  modelName = "",
  vin = "",
  status = "",
  dateFrom = "1970-01-01",
  dateTo,
  orderTrackingUniqueId
) => {
  if (sortBy.length > 0) {
    if (sortBy == "Model Name") {
      sortBy = "modelName";
    } else if (sortBy === "Manufacture Year") {
      sortBy = "year";
    } else if (sortBy === "status") {
      sortBy = "status";
    } else if (sortBy === "Order Number") {
      sortBy = "requestId";
    } else if (sortBy === "Total Items") {
      sortBy = "sparePartsLength";
    } else if (sortBy === "Brand Name") {
      sortBy = "brandName";
    } else if (sortBy === "Created On") {
      sortBy = "createdAt";
    }else if (orderTrackingUniqueId === "Tracking Id") {
      sortBy = "orderTrackingUniqueId";
    }
  }
  // else {
  //   sortBy = "createdAt";
  // }
  order = order.length > 0 ? order : "desc";

  dateFrom = dateFrom.length > 0 ? dateFrom : "1970-01-01";

  dateTo = dateTo ? addOneToDate(new Date(dateTo)) : addOneToDate(new Date());

  return `${apiName}?page=${page}&per_page=${per_page}&sortBy=${sortBy}&orderBy=${order}&isActive=${isActive}&requestId=${requestId}&customer=${customer}&brandName=${brandName}&modelName=${modelName}&vin=${vin}&status=${status}&dateFrom=${dateFrom}&dateTo=${dateTo}&orderTrackingUniqueId=${orderTrackingUniqueId}`;
};

const ViewAll = () => {
  const dispatch = useDispatch();
  const [dataList, setDataList] = useState([]);
  const [allModels, setAllModels] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [perPage, setPerPage] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "createdAt",
    order: "desc",
  });
  const [brands, setBrands] = useState([]);

  const { records_per_page } = useSelector((state) => state.setting);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
    setError,
    watch,
  } = useForm();

  const { request, response } = useRequest();

  const { request: requestModel, response: responseModel } = useRequest();
  const { request: requestBrands, response: responseBrands } = useRequest();

  useEffect(() => {
    requestBrands("GET", "brand");
  }, []);

  useEffect(() => {
    if (responseBrands) {
      setBrands(responseBrands?.data);
    }
  }, [responseBrands]);

  useEffect(() => {
    const { brandName } = getValues();

    if (brandName != "" && brandName != undefined) {
      requestModel("GET", `brand-model/model/${brandName}`);
    }
  }, [watch("brandName")]);

  useEffect(() => {
    if (responseModel) {
      setAllModels(responseModel.modelData);
    }
  }, [responseModel]);

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      let {
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        status,
        dateFrom,
        dateTo,
        orderTrackingUniqueId
      } = getValues();
      request(
        "GET",
        searchQueryHandler(
          page,
          records_per_page,
          currentSort.sortBy,
          currentSort.order,
          isActive,
          requestId,
          customer,
          brandName,
          modelName,
          vin,
          status,
          dateFrom,
          dateTo,
          orderTrackingUniqueId
        )
      );
    }
    document.title = `${titlePlural} - Easyspare`;
  }, []);

  useEffect(() => {
    if (response) {
      setDataList(response?.orders?.newOrders);
      setTotalDocuments((prev) => response?.orders?.totalDocuments ?? prev);
    }
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setDataList([]);
    let {
      isActive,
      requestId,
      customer,
      contact,
      email,
      brandName,
      modelName,
      vin,
      status,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();

    if (brandName) {
      let filterData = brands.find((item) => item._id == brandName);
      brandName = filterData.name;
    }

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        status,
        dateFrom,
        dateTo,
        orderTrackingUniqueId
      )
    );
  };

  const onSearchHandler = (data) => {
    let {
      isActive,
      requestId,
      customer,
      brandName,
      modelName,
      vin,
      status,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();

    if (brandName) {
      let filterData = brands.find((item) => item._id == brandName);

      brandName = filterData.name;
    }

    if (dateFrom && dateTo) {
      if (Moment(dateFrom).isAfter(dateTo)) {
        setError("dateTo", {
          type: "manual",
        });
        return;
      }
    }
    request(
      "GET",
      searchQueryHandler(
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        status,
        dateFrom,
        dateTo,
        orderTrackingUniqueId
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("requestId");
    resetField("customer");
    resetField("brandName");
    resetField("modelName");
    resetField("vin");
    resetField("status");
    resetField("dateFrom");
    resetField("dateTo");
    resetField("orderTrackingUniqueId");
    setAllModels([]);
    request(
      "GET",
      searchQueryHandler(1, perPage, currentSort.sortBy, currentSort.order)
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    let {
      isActive,
      customer,
      brandName,
      modelName,
      requestId,
      vin,
      contact,
      status,
      email,
      country,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();
    if (brandName) {
      let filterData = brands.find((item) => item._id == brandName);
      brandName = filterData.name;
    }

    request(
      "GET",
      searchQueryHandler(
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        status,
        dateFrom,
        dateTo,
        orderTrackingUniqueId
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const handleChangeBrand = () => {
    // let { brandName } = getValues();
    // console.log(brandName, "brandName");
  };

  const sortingHandler = (sortBy) => {
    let {
      isActive,
      customer,
      brandName,
      contact,
      modelName,
      requestId,
      email,
      vin,
      status,
      country,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();
    if (brandName) {
      let filterData = brands.find((item) => item._id == brandName);

      brandName = filterData.name;
    }
    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          newOrder,
          isActive,
          requestId,
          customer,
          brandName,
          modelName,
          vin,
          status,
          dateFrom,
          dateTo,
          orderTrackingUniqueId
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          "desc",
          isActive,
          requestId,
          customer,
          brandName,
          modelName,
          vin,
          status,
          dateFrom,
          dateTo,
          orderTrackingUniqueId
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const InputFields = [
    {
      label: "Order Number",
      name: "requestId",
      required: false,
    },
    {
      label: "Customer Name",
      name: "customer",
      required: false,
    },
    {
      label: "Tracking Id",
      name: "orderTrackingUniqueId",
      required: false,
    },
    {
      isSelectInput: true,
      label: "Brand Name",
      name: "brandName",
      required: false,
      onChange: handleChangeBrand,
      children: (
        <>
          <option value="">{"Select an option"}</option>
          {brands?.length > 0 &&
            brands.map((item, index) => {
              return (
                <option value={item?._id} key={index}>
                  {item?.name}
                </option>
              );
            })}
        </>
      ),
    },
    {
      isSelectInput: true,
      label: "Model Name",
      name: "modelName",
      required: false,
      children: (
        <>
          <option value="">{"Select an option"}</option>
          {allModels?.length > 0 &&
            allModels.map((item, index) => {
              return (
                <option value={item?.name} key={index}>
                  {item?.name}
                </option>
              );
            })}
        </>
      ),
    },
    // {
    //   isSelectInput: true,
    //   label: "Model Name",
    //   name: "modelName",
    //   required: false,
    //   children: (
    //     <>
    //       <option value="">{"Select an option"}</option>
    //       <option value={true}> {"Request Submitted"}</option>
    //       <option value={false}>{"Offer Received"}</option>
    //       <option value={true}> {"Order Confirmed"}</option>
    //       <option value={true}> {"Order Canelled"}</option>
    //       <option value={true}> {"Order Delivered"}</option>
    //       <option value={true}> {"Order Returned"}</option>
    //     </>
    //   ),
    // },
    {
      label: "Vin",
      name: "vin",
      required: false,
    },

    {
      isSelectInput: true,
      label: "Status",
      name: "status",
      required: false,
      children: (
        <>
          <option value="">{"Select an option"}</option>
          <option value="request_submitted"> {"Request Submitted"}</option>
          <option value="offer_received">{"Offer Received"}</option>
          <option value="order_confirmed"> {"Order Confirmed"}</option>
          <option value="order_canelled"> {"Order Canelled"}</option>
          <option value="order_delivered"> {"Order Delivered"}</option>
          <option value="order_partially_returned">
            {" "}
            {"Order Partially Returned"}
          </option>
          <option value="order_returned"> {"Order Returned"}</option>
        </>
      ),
    },
    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "'To Date' cannot be smaller than 'From Date'",
      },
    },
  ];
  const linksHelperFn = (name, data) => {
    if (data?.status === "Order Confirmed") {
      return "OrderDelivered";
    }
  };
  const deliverHandler = async (id) => {
    let {
      isActive,
      requestId,
      customer,
      brandName,
      modelName,
      vin,
      status,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();
    const swal = await ConfirmButton(
      "Delivered",
      "Are you sure you want to mark this order as delivered?"
    );
    if (swal.isConfirmed) {
      const response = await requestHandler(
        "PUT",
        "orders/admin/deliver_order",
        { id },
        dispatch
      );

      if (response?.status) {
        toast.success(response.message);
        request(
          "GET",
          searchQueryHandler(
            page,
            perPage,
            currentSort.sortBy,
            currentSort.order,
            isActive,
            requestId,
            customer,
            brandName,
            modelName,
            vin,
            status,
            dateFrom,
            dateTo,
            orderTrackingUniqueId
          )
        );
      }
    }
  };

  const deleteHandler = async (id) => {
    const swal = await ConfirmButton(
      "Yes, delete it",
      "Are you sure you want to permanently delete this order? This cannot be undone."
    );
    if (!swal.isConfirmed) return;

    const response = await requestHandler(
      "DELETE",
      "orders",
      { id },
      dispatch
    );

    if (response?.status) {
      toast.success(response.message);
      setDataList((prev) => prev.filter((list) => list._id != id));
      setTotalDocuments((prev) => Math.max(0, (prev || 0) - 1));
    }
  };

  const exportCsv = async () => {
    let {
      requestId,
      customer,
      brandName,
      modelName,
      vin,
      status,
      dateFrom,
      dateTo,
      orderTrackingUniqueId
    } = getValues();
    if (currentSort.sortBy.length > 0) {
      if (currentSort.sortBy == "Model Name") {
        currentSort.sortBy = "modelName";
      } else if (currentSort.sortBy === "Manufacture Year") {
        currentSort.sortBy = "year";
      } else if (currentSort.sortBy === "status") {
        currentSort.sortBy = "status";
      } else if (currentSort.sortBy === "Order Number") {
        currentSort.sortBy = "requestId";
      } else if (currentSort.sortBy === "Total Items") {
        currentSort.sortBy = "sparePartsLength";
      } else if (currentSort.sortBy === "Brand Name") {
        currentSort.sortBy = "brandName";
      } else if (currentSort.sortBy === "Created On") {
        currentSort.sortBy = "createdAt";
      } else if (currentSort.sortBy == 'Tracking Id') {
        currentSort.sortBy = 'orderTrackingUniqueId'
      }
    }

    dispatch(updateLoading(true));
    let uri = `${apiName}/export-csv?sortBy=${currentSort.sortBy}&orderBy=${currentSort.order}`;

    if (requestId) uri += `&requestId=${requestId}`;
    if (brandName) uri += `&brandName=${brandName}`;
    if (modelName) uri += `&modelName=${modelName}`;
    if (dateFrom) uri += `&dateFrom=${dateFrom}`;
    if (customer) uri += `&customer=${customer}`;
    if (dateTo) uri += `&dateTo=${dateTo}`;
    if (status) uri += `&status=${status}`;
    if (vin) uri += `&vin=${vin}`;
    if (orderTrackingUniqueId) uri += `&orderTrackingUniqueId=${orderTrackingUniqueId}`;

    const response = await requestHandler(
      "GET",
      uri,
      {
        responseType: "blob", // Ensure response type is set to blob
      },
      dispatch
    );
    dispatch(updateLoading(false));

    if (!response) {
      return toast.error("Record not found.");
    }
    // Create a blob from the response data
    const blob = new Blob([response], { type: "text/csv" });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = `orders-${moment().toISOString()}.csv`; // Setting the filename
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up resources
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title={titlePlural}
        links={[{ to: "/", name: "Dashboard" }]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      /*href="#!"*/
                      className="btn btn-primary dropdown-toggle mr-2"
                      data-toggle="collapse"
                      data-target="#collapseOne6"
                    >
                      Search
                    </a>
                    {/* <div>
                      <JsonToScv
                        headers={csvHeader}
                        data={dataList}
                        filename={`orders-${moment().toISOString()}.csv`}
                      />
                    </div> */}
                    <div onClick={exportCsv} className="cursor-pointer">
                      <img
                        src="/csv.png"
                        width={45}
                        height={45}
                        title="Export CSV"
                      />
                    </div>
                    {/* {((roleId === 2 && !!permission["3_2"]) || roleId == 1) && (
                      <Link to="/orders/add" className="btn btn-primary">
                        Add New {titleSingular}
                      </Link>
                    )} */}
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse"
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                              />
                            ))}
                          </div>

                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="dataTables_wrapper ">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={dataList}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      linksHelperFn={linksHelperFn}
                      renderAs={{
                        profilePic: (val) =>
                          val ? (
                            <img
                              src={`${API.PORT}/${val}`}
                              alt="img"
                              style={{ width: "70px" }}
                            />
                          ) : (
                            ""
                          ),
                        customer: (val, data, id) =>
                          id ? (
                            <div>
                              {/* {id ? id.customer  + "," + id.contact : "-"} */}
                              <span>{id.customer}</span>
                              <br /> <span>{id.email}</span>
                              <br />{" "}
                              <span>{id.contact ? "+" + id.contact : ""}</span>
                            </div>
                          ) : (
                            ""
                          ),

                        status: (val) =>
                          val ? (
                            <span
                              style={{ height: "40px" }}
                              className={`label label-lg label-light-${
                                val === "Order Confirmed" ||
                                val === "Request Submitted" ||
                                val === "Order Delivered"
                                  ? "success"
                                  : val === "Offer Received"
                                  ? "warning"
                                  : val === "Order Returned" ||
                                    val === "Order Partially Returned" ||
                                    val === "Order Cancelled"
                                  ? "danger"
                                  : ""
                              } label-inline`}
                            >
                              {val}
                            </span>
                          ) : (
                            ""
                          ),
                      }}
                      links={[
                        // {
                        //   isLink: false,
                        //   name: "Deactivate",
                        //   // click: changeStatusHandler,
                        //   title: "Click To Activate",
                        //   key: "3_3",
                        // },
                        // {
                        //   isLink: false,
                        //   name: "Activate",
                        //   // click: changeStatusHandler,
                        //   title: "Click To Deactivate",
                        //   key: "3_3",
                        // },
                        {
                          isLink: false,
                          name: "TrackingId",
                          click: (id, data) => {
                            setShowModal(true);
                            setModalData(data);
                          },
                          key: "3_3",
                        },
                        {
                          isLink: true,
                          to: "/orders/view",
                          name: "View",
                          extraData: true,
                          key: "3_4",
                        },
                        {
                          isLink: false,
                          name: "Mark Deliver",
                          click: deliverHandler,
                          key: "11_1",
                        },
                        {
                          isLink: false,
                          name: "Delete",
                          click: deleteHandler,
                          key: "3_6",
                        },
                      ]}
                      onlyDate={{
                        createdAt: "dateTime",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                    />

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={dataList?.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <AddTrackingId
          setShowModal={handleCloseModal}
          showModal={showModal}
          orderData={modalData}
          setDataList={setDataList}
        />
      ) : null}
    </div>
  );
};

export default ViewAll;
